import React from 'react';
import { i18n } from 'config/locales';

import {
  CommonOnUpdate, CommonOnError, CommonScrollIntoView, CommonRequired
} from 'types/props';
import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import classnames from 'classnames';
import {
  BranchCollectionModel,
  TelephoneItemModel
} from 'forms/shared/types';
import BranchCollection from 'components/Form/BranchCollection';
import TelephoneCollectionItem from './TelephoneCollectionItem';

/*
 This component was designed to be functionally similar to AdditionalActivity,
 See that component if this one appears broke to determine what action to take.
*/

type TelephoneCollectionType = BranchCollectionModel<TelephoneItemModel>;

interface Props extends ValidationElementProps, Partial<TelephoneCollectionType> {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  className?: string
  scrollIntoView?: CommonScrollIntoView
  required?: CommonRequired
  attribute?: string
  emailBranchQuestionLabel?:string
  telephoneFieldTitle?: string
  appendFieldTitle?: string
  branchFieldTitle?: string
  showTimeOfDay?: boolean
  timeOfDayLabel?: string
  allowNotApplicable?: boolean
  hideInitialBranchQuestion?: boolean
}

export default class TelephoneCollection extends ValidationElement<Props> {
  updateBranch = (values: Partial<TelephoneCollectionType>) => {
    // TODO: FOr MVP I'm letting the extra question exist for Do you have telephone?
    // if this is impermissable then we will need to add logic here to ensure the
    // branch always has one item. I do exepect this will be done before full release.
    this.props.onUpdate({
      ...values,
    });
  };

  render() {
    return (
      <div className={classnames('telephone-list', this.props.className)}>
        <BranchCollection
          label={this.props.branchFieldTitle}
          labelSize="h4"
          appendLabel={this.props.appendFieldTitle}
          appendSize="h4"
          {...(this.props || {})}
          onUpdate={this.updateBranch}
          onError={this.props.onError}
          scrollIntoView={this.props.scrollIntoView}
          hideInitialBranchQuestionAssumeYes={this.props.hideInitialBranchQuestion} // TODO: this is temporary until all uses of this component can appropriately transition from using the initial branch question IDK to another solution
        >
          <TelephoneCollectionItem
            attribute={this.props.attribute}
            telephoneFieldTitle={this.props.telephoneFieldTitle}
            name="Item"
            bind
            required={this.props.required}
            showTimeOfDay={this.props.showTimeOfDay}
            timeOfDayLabel={this.props.timeOfDayLabel}
            allowNotApplicable={this.props.allowNotApplicable}
          />
        </BranchCollection>
      </div>
    );
  }
}

TelephoneCollection.defaultProps = {
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
  telephoneFieldTitle: 'What is the telephone?',
  appendFieldTitle: 'Do you have another telephone to add?',
  branchFieldTitle: 'Do you have a telephone to add?',
  showTimeOfDay: false,
  allowNotApplicable: false,
  hideInitialBranchQuestion: false,
};
